"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PaginationViewReducer = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _apiPaginationView = require("../actions/apiPaginationView");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PaginationViewReducer = exports.PaginationViewReducer = function PaginationViewReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];


	var newState = {};
	switch (action.type) {
		case _apiPaginationView.API_PAGINATION_VIEW_REQUEST:
			return _lodash2.default.merge({}, state, _defineProperty({}, action.options.VIEW, {
				loading: true,
				error: null,
				RESET: action.options.RESET
			}));

		case _apiPaginationView.API_PAGINATION_VIEW_FAILURE:
			return _lodash2.default.merge({}, state, _defineProperty({}, action.view, {
				loading: false,
				error: action.payload.error
			}));

		case _apiPaginationView.API_PAGINATION_VIEW_SUCCESS:
			// console.log(_.toPath([action.view, "DATA"]));
			newState = _lodash2.default.assign({}, state, _defineProperty({}, action.view, _lodash2.default.assign({
				loading: false,
				error: null
			}, action.payload.data.VIEW_DATA, action.reset ? null : {
				DATA: _lodash2.default.concat(_lodash2.default.get(state, [action.view, "DATA"], []), action.payload.data.VIEW_DATA.DATA)
			})));
			return newState;

		default:
			return state;
	}
};